/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AlanUserRegistrationSchema {
  /**
   * Sub Id 1
   * @minLength 1
   */
  sub_id_1?: string
  /**
   * Sub Id 10
   * @minLength 1
   */
  sub_id_10?: string
  /**
   * Sub Id 2
   * @minLength 1
   */
  sub_id_2?: string
  /**
   * Sub Id 3
   * @minLength 1
   */
  sub_id_3?: string
  /**
   * Sub Id 4
   * @minLength 1
   */
  sub_id_4?: string
  /**
   * Sub Id 5
   * @minLength 1
   */
  sub_id_5?: string
  /**
   * Sub Id 6
   * @minLength 1
   */
  sub_id_6?: string
  /**
   * Sub Id 7
   * @minLength 1
   */
  sub_id_7?: string
  /**
   * Sub Id 8
   * @minLength 1
   */
  sub_id_8?: string
  /**
   * Sub Id 9
   * @minLength 1
   */
  sub_id_9?: string
  /**
   * Alan Click Id
   * @format uuid
   */
  alan_click_id: string
  /** Creative Id */
  creative_id: number
  /** Offer Id */
  offer_id: number
  /** Partner Id */
  partner_id: number
}

export interface BadRequestMessage {
  /**
   * Code
   * @min 1
   * @max 2147483647
   */
  code?: number
  /**
   * Detail
   * @default "Bad request"
   */
  detail?: string
}

export interface CDALandingsResponse {
  /**
   * Balancer
   * @minLength 1
   */
  balancer: string
  /** Landing To Balancer */
  landing_to_balancer?: Record<string, string>
}

export interface CdaIpInfoResponse {
  /** Alpha 2 */
  alpha_2: string
  /** Alpha 3 */
  alpha_3: string
}

export interface CountryWithImageResponse {
  /** Alpha2 */
  alpha2: string
  /** Alpha3 */
  alpha3: string
  /** Country Phone Code */
  country_phone_code?: number
  /**
   * Created
   * @format date-time
   */
  created: string
  /** Currency Id */
  currency_id?: string
  /**
   * Default Locale
   * @minLength 1
   */
  default_locale?: string
  /**
   * Id
   * @min 1
   * @max 2147483647
   */
  id: number
  /**
   * Image
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  image?: string
  /** In Registration */
  in_registration: boolean
  /** Is Forbidden By Api */
  is_forbidden_by_api: boolean
  /**
   * Locales
   * @minItems 1
   */
  locales?: string[]
  /**
   * Modified
   * @format date-time
   */
  modified?: string
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Numeric */
  numeric?: number
  /**
   * Official Name
   * @maxLength 255
   */
  official_name?: string
}

export interface DetailUnavailableForLegalReasonsMessage {
  /** Country Code */
  country_code: string
  /** Msg */
  msg: string
}

export interface ForbiddenMessage {
  /**
   * Code
   * @min 1
   * @max 2147483647
   */
  code?: number
  /**
   * Detail
   * @default "Not authenticated"
   */
  detail?: string
}

export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[]
}

export interface LandingUserRegistrationSchema {
  /** An enumeration. */
  account_registered_by: PublicAccountRegistrationTypeEnum
  alan?: AlanUserRegistrationSchema
  /**
   * Bonus Id
   * @min 1
   * @max 2147483647
   */
  bonus_id?: number
  /** Btag */
  btag?: string
  /** Clean Phone */
  clean_phone?: number
  /** Country Of Residence */
  country_of_residence?: string
  /** Currency */
  currency?: string
  /**
   * Domain
   * @minLength 1
   * @maxLength 128
   */
  domain?: string
  /**
   * Email
   * @format email
   */
  email?: string
  /**
   * Language
   * @minLength 2
   * @maxLength 6
   * @pattern ^([a-z]{2,3}-[A-Z]{2}$)|^([a-z]{2}$)
   */
  language: string
  /**
   * Password
   * @minLength 8
   * @maxLength 128
   */
  password?: string
  /** Phone Country Code */
  phone_country_code?: string
  ppp?: PPPUserRegistrationSchema
  /**
   * Privacy Policy
   * @default false
   */
  privacy_policy?: boolean
  /** Receive Promos Enabled */
  receive_promos_enabled?: boolean
  /** Referral Code */
  referral_code?: string
  /**
   * Stag
   * @pattern ^[0-9]++\_([0-9a-f]{24}|[0-9]+)$
   */
  stag?: string
  /**
   * Telegram Token
   * @minLength 1
   */
  telegram_token?: string
  /**
   * Terms And Conditions
   * @default false
   */
  terms_and_conditions?: boolean
}

export interface NotFoundMessage {
  /**
   * Code
   * @min 1
   * @max 2147483647
   */
  code?: number
  /** Detail */
  detail: string
}

export interface PPPUserRegistrationSchema {
  /**
   * Subid1
   * @minLength 1
   */
  subId1?: string
  /**
   * Subid2
   * @minLength 1
   */
  subId2?: string
  /**
   * Subid3
   * @minLength 1
   */
  subId3?: string
  /**
   * Subid4
   * @minLength 1
   */
  subId4?: string
  /**
   * Subid5
   * @minLength 1
   */
  subId5?: string
  /**
   * St
   * @minLength 1
   */
  st?: string
}

export enum PublicAccountRegistrationTypeEnum {
  Email = 'email',
  Google = 'google',
  Discord = 'discord',
  PhoneNumber = 'phone_number',
}

export interface PublicCountryFilter {
  /** Is Forbidden By Api */
  is_forbidden_by_api?: boolean
}

export interface RegisteredUserBonusInfoSchema {
  /**
   * Bonus Id
   * @min 1
   * @max 2147483647
   */
  bonus_id: number
  /** Promo Code */
  promo_code?: string
  /** Status */
  status: UserBonusStatusEnum | 'assigned'
}

export interface UnavailableForLegalReasonsMessage {
  /** Detail */
  detail: DetailUnavailableForLegalReasonsMessage[]
}

export interface UserAutologinResponse {
  /**
   * Autologin Token
   * @minLength 1
   */
  autologin_token: string
  /** Domains */
  domains: string[]
  /**
   * Session Id Override
   * @min 1
   * @max 2147483647
   */
  session_id_override: number
  /**
   * User Bonuses
   * @minItems 1
   */
  user_bonuses?: RegisteredUserBonusInfoSchema[]
  /**
   * User Id
   * @min 1
   * @max 2147483647
   */
  user_id: number
}

export enum UserBonusStatusEnum {
  InProgress = 'in_progress',
  CancelledByPlayer = 'cancelled_by_player',
  CancelledByAdmin = 'cancelled_by_admin',
  Lost = 'lost',
  Expired = 'expired',
  Paid = 'paid',
  ReadyToRelease = 'ready_to_release',
  Granted = 'granted',
}

export interface UserCDAInfoResponseSchema {
  /** Autologin Token */
  autologin_token: string
  /** Domains */
  domains: string[]
  /** Session Id Override */
  session_id_override: number
}

export interface ValidationError {
  /** Location */
  loc: (string | number)[]
  /** Message */
  msg: string
  /** Error Type */
  type: string
}

import { ContentType, HttpClient, RequestParams } from '../../HttpClient'

/**
 * @title FastAPI
 * @version 0.1.0
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  core = {
    /**
     * No description
     *
     * @tags users
     * @name PublicCountryList
     * @summary Public Country List
     * @request GET:/core/public/v1/users/country
     * @secure
     */
    publicCountryList: (
      query?: {
        /**
         * Filter
         * @default {}
         */
        filter?: PublicCountryFilter
        order_by?: string[]
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        CountryWithImageResponse[],
        | BadRequestMessage
        | ForbiddenMessage
        | NotFoundMessage
        | HTTPValidationError
        | UnavailableForLegalReasonsMessage
      >({
        path: `/core/public/v1/users/country`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name PublicLandingUserRegistrationCreate
     * @summary Public Landing User Registration Create
     * @request POST:/core/public/v1/users/landing_registration
     * @secure
     */
    publicLandingUserRegistrationCreate: (
      data: LandingUserRegistrationSchema,
      query?: {
        /**
         * Source Url
         * @format uri
         * @minLength 1
         * @maxLength 2083
         */
        source_url?: string
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        UserAutologinResponse,
        | BadRequestMessage
        | ForbiddenMessage
        | NotFoundMessage
        | HTTPValidationError
        | UnavailableForLegalReasonsMessage
      >({
        path: `/core/public/v1/users/landing_registration`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name CdaDomainsRetrieve
     * @summary Cda Domains Retrieve
     * @request GET:/core/v1/users/cda/check
     * @secure
     */
    cdaDomainsRetrieve: (params: RequestParams = {}) =>
      this.http.request<
        UserCDAInfoResponseSchema,
        | BadRequestMessage
        | ForbiddenMessage
        | NotFoundMessage
        | HTTPValidationError
        | UnavailableForLegalReasonsMessage
      >({
        path: `/core/v1/users/cda/check`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  cda = {
    /**
     * No description
     *
     * @tags cda
     * @name PublicCdaV2LandingsRetrieve
     * @summary Public Cda V2 Landings Retrieve
     * @request GET:/cda/public/v2/info
     */
    publicCdaV2LandingsRetrieve: (
      query: {
        /** Project Id */
        project_id: string
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        CDALandingsResponse,
        | BadRequestMessage
        | ForbiddenMessage
        | NotFoundMessage
        | HTTPValidationError
        | UnavailableForLegalReasonsMessage
      >({
        path: `/cda/public/v2/info`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags cda
     * @name PublicCdaV2IpInfoRetrieve
     * @summary Public Cda V2 Ip Info Retrieve
     * @request GET:/cda/public/v2/ip/info
     */
    publicCdaV2IpInfoRetrieve: (params: RequestParams = {}) =>
      this.http.request<
        CdaIpInfoResponse,
        | BadRequestMessage
        | ForbiddenMessage
        | NotFoundMessage
        | HTTPValidationError
        | UnavailableForLegalReasonsMessage
      >({
        path: `/cda/public/v2/ip/info`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
}
